<script lang="ts">
  import Avatar from "$components/+blocks/Avatar/Avatar.svelte";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import { primaryColor, logoImage, isPrivateCommunity, community } from "$stores/community";
  import { LockSolid } from "$components/+blocks/OVIcon";
</script>

<div class="relative block">
  <Avatar
    mainImage={$logoImage}
    size="size-9"
    radius="rounded-md"
    backgroundColor={$primaryColor}
    label={$community.name?.[0]}
  />
  {#if $isPrivateCommunity}
    <OVIcon
      size="size-2.5"
      icon={LockSolid}
      class="absolute -right-0.5 -bottom-0.5 rounded-[3px] bg-white p-[0.5px] text-gray-500 dark:bg-gray-700 dark:text-gray-300"
    />
  {/if}
  <slot />
</div>
